// src/components/Navbar.js
import React, { useState, useEffect } from 'react';
import './navbar.css';
import Logo from '../components/images/Log.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const toggleMenu = () => {
    setIsOpen((open) => !open);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`navbar ${isSticky ? 'sticky' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          {/* <a href="/">
            <span>Kod</span>e<span>X</span>
          </a> */}

          <a href="#home" aria-label="Kodex Solutions home">
            <img id="logo" src={Logo} alt="Kodex Solutions" />
          </a>
        </div>
        <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
          <li className="nav-item">
            <a href="#home" onClick={() => setIsOpen(false)}>
              Home
            </a>
          </li>
          <li className="nav-item">
            <a href="#about" onClick={() => setIsOpen(false)}>
              About
            </a>
          </li>
          <li className="nav-item">
            <a href="#services" onClick={() => setIsOpen(false)}>
              Services
            </a>
          </li>
          <li className="nav-item">
            <a href="#project" onClick={() => setIsOpen(false)}>
              Project
            </a>
          </li>
          <li className="nav-item">
            <a href="#customer" onClick={() => setIsOpen(false)}>
              Customer
            </a>
          </li>
          <li className="nav-item">
            <a href="#out-team" onClick={() => setIsOpen(false)}>
              Team
            </a>
          </li>
          <li className="nav-item">
            <a href="#contact" onClick={() => setIsOpen(false)}>
              Contact
            </a>
          </li>
        </ul>
        <div className="navbar-login">
          <a href="#contact" className="btn-login">
            Let's talk
          </a>
          <i className="bx bxs-user-plus bx-tada"></i>
        </div>
        {/* <div className="theme-toggle-icon" onClick={toggleTheme}>
          <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
        </div> */}
        <button
          type="button"
          className={`hamburger ${isOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isOpen}
        >
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
